export default __webpack_public_path__ + "static/03-02-analysis-class-wide-cbd98c55fa0ab1650820779a7ab45866.gif";